import { createSelector } from "reselect";
import { AppState } from "../rootReducer";

// GET access controls

const getAccessControl = (state: AppState) => state.accessControl;

//insitu Extractor list
const getInsituListPending = (state: AppState) => state.insituExtractors.pending;
const getInsituList = (state: AppState) => state.insituExtractors.insituExtractors;
const getInsituListError = (state: AppState) => state.insituExtractors.error;


export const getInsituListSelector = createSelector(getInsituList, (insituExtractor) => insituExtractor);
export const getInsituListPendingSelector = createSelector(getInsituListPending, (pending) => pending);
export const getInsituListErrorSelector = createSelector(getInsituListError, (error) => error);

//  Insitu Extractor Details

const getInsituExtractorDetailsPending = (state: AppState) => state.insituExtractorDetails.pending;
const getInsituExtractorDetails = (state: AppState) => state.insituExtractorDetails.insituExtractor;
const getInsituExtractorDetailsError = (state: AppState) => state.insituExtractorDetails.error;

export const getInsituExtractorDetailsSelector = createSelector(getInsituExtractorDetails, (insituExtractor) => insituExtractor);
export const getInsituExtractorDetailsPendingSelector = createSelector(getInsituExtractorDetailsPending, (pending) => pending);
export const getInsituExtractorDetailsErrorSelector = createSelector(getInsituExtractorDetailsError, (error) => error);

//Post Insitu Extractors
const postInsituExtractorPending = (state: AppState) => state.postInsituExtractor.pending;
const postInsituExtractorExtractor = (state: AppState) => state.postInsituExtractor.insituExtractor;
const postInsituExtractorError = (state: AppState) => state.postInsituExtractor.error;

export const postInsituExtractorPendingSelector = createSelector(postInsituExtractorPending, (pending) => pending);
export const postInsituExtractorSelector = createSelector(postInsituExtractorExtractor, (extractor) => extractor);
export const postInsituExtractorErrorSelector = createSelector(postInsituExtractorError, (error) => error);

//put Insitu Extractors
const putInsituExtractorPending = (state: AppState) => state.putInsituExtractor.pending;
const putInsituExtractorExtractor = (state: AppState) => state.putInsituExtractor.insituExtractor;
const putInsituExtractorError = (state: AppState) => state.putInsituExtractor.error;

export const putInsituExtractorPendingSelector = createSelector(putInsituExtractorPending, (pending) => pending);
export const putInsituExtractorSelector = createSelector(putInsituExtractorExtractor, (extractor) => extractor);
export const putInsituExtractorErrorSelector = createSelector(putInsituExtractorError, (error) => error);

//delete Insitu Extractors
const deleteInsituExtractorPending = (state: AppState) => state.deleteInsituExtractor.pending;
const deleteInsituExtractorExtractor = (state: AppState) => state.deleteInsituExtractor.deleteStatus;
const deleteInsituExtractorError = (state: AppState) => state.deleteInsituExtractor.error;

export const deleteInsituExtractorPendingSelector = createSelector(deleteInsituExtractorPending, (pending) => pending);
export const deleteInsituExtractorSelector = createSelector(deleteInsituExtractorExtractor, (extractor) => extractor);
export const deleteInsituExtractorErrorSelector = createSelector(deleteInsituExtractorError, (error) => error);

export const getAccessControlSelector = createSelector(getAccessControl, (accessControl) => accessControl.accessControls);
export const getAccessControlPendingSelector = createSelector(getAccessControl, (accessControl) => accessControl.pending);